module.exports = __webpack_public_path__ + "videos/jarom-v2.b57591e.mp4";